
const digest = 'aaab56e119ff6c443247f8862bf235a3d546c44b4bd99c167a81d8d8bc09c882';
const classes = {"wrapper":"_wrapper_1kyus_1","date":"_date_1kyus_13","content":"_content_1kyus_19","title":"_title_1kyus_22","subTitle":"_subTitle_1kyus_26","controls":"_controls_1kyus_30","inPatientsECard":"_inPatientsECard_1kyus_36","check":"_check_1kyus_43"};
const css = `._wrapper_1kyus_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1kyus_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_1kyus_1 ._date_1kyus_13 {
  font-size: 14px;
  color: #000000;
  min-width: 120px;
  max-width: 120px;
}
._wrapper_1kyus_1 ._content_1kyus_19 {
  flex-grow: 1;
}
._wrapper_1kyus_1 ._content_1kyus_19 ._title_1kyus_22 {
  color: #000000;
  font-weight: 500;
}
._wrapper_1kyus_1 ._content_1kyus_19 ._subTitle_1kyus_26 {
  color: #000000;
  font-size: 14px;
}
._wrapper_1kyus_1 ._controls_1kyus_30 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
._wrapper_1kyus_1 ._controls_1kyus_30 ._inPatientsECard_1kyus_36 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
  font-weight: 600;
}
._wrapper_1kyus_1 ._controls_1kyus_30 ._inPatientsECard_1kyus_36 ._check_1kyus_43 {
  width: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  